const UiPath = () => (
  <img alt="UiPath logo" src="/img/customer-logos/uipath-logo-white.svg" />
);

export default UiPath;
